import { render, staticRenderFns } from "./MToggleList.vue?vue&type=template&id=2070a5e4&"
import script from "./MToggleList.vue?vue&type=script&lang=ts&"
export * from "./MToggleList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports